import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import Icon from '../../../../../../atoms/Icon'
import { useDocumentDownload } from '../../../../../../../api/documentVault'
import { usePolicy } from '../../../../../../../hooks/usePolicy'
import { useRemoveComment } from '../../../../../../../api/comments'

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: ({ disabled }) => disabled === 'removed' ? 'none' : 'flex'
  },
  attachment: {
    display: 'flex',
    border: 'var(--border-neutral-thin)',
    background: 'var(--color-surface-050)',
    padding: 'var(--dim-1) var(--dim-2)',
    borderRadius: 'var(--border-radius-sm)',
    gap: 'var(--dim-1)',
    alignItems: 'center',
    fontSize: 'var(--font-size-xs)',
    cursor: 'pointer'
  },
  info: {
    flex: '1 0'
  },
  name: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between'
  },
  trash: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 'var(--dim-2)'
  }
}))

function Attachment ({ attachment, onRemoveAttachment }) {
  const canRemoveAttachments = usePolicy('attachments_remove')

  const removeAttachmentMutation = useRemoveComment()

  const [disabled, setDisabled] = useState()
  const handleRemove = useCallback(async () => {
    if (disabled) {
      return
    }
    setDisabled('wait')
    try {
      await removeAttachmentMutation.mutateAsync(attachment)
      setDisabled('removed')
    } catch (err) {
      alert('Error: Couldn\'t Remove the selected document attachment.')
      setDisabled(null)
    }
  }, [attachment, disabled, removeAttachmentMutation])

  const { mutateAsync: download } = useDocumentDownload()
  const handleDownload = useCallback(async () => {
    if (disabled) {
      return
    }
    setDisabled('wait')
    try {
      await download(attachment.document, false)
    } finally {
      setDisabled(null)
    }
  }, [attachment, download, disabled, setDisabled])

  const classes = useStyles({ disabled })

  return (
    <div className={classes.wrapper}>
      <div
        className={clsx(classes.attachment, { __disabled: disabled === 'wait' })}
        role='button'
        onClick={handleDownload}
        title='Download Document'
      >
        <Icon
          name='document'
          customSize={12}
        />
        <div className={classes.name}>
          {attachment.document.name}
        </div>
        {canRemoveAttachments ? (
          <div
            className={clsx(classes.trash, { __disabled: disabled === 'wait' })}
            role='button'
            onClick={handleRemove}
            title='Remove Attachment'
          >
            <Icon customSize={12} name='delete' />
          </div>
        ) : null}
      </div>
    </div>
  )
}

Attachment.propTypes = {
  attachment: PropTypes.shape({
    attachmentId: PropTypes.number,
    levelTypeId: PropTypes.number,
    levelId: PropTypes.number,
    documentId: PropTypes.string,
    document: PropTypes.shape({
      name: PropTypes.string,
      thumbnailKey: PropTypes.string,
      documentType: PropTypes.string,
      createdDate: PropTypes.string
    })
  }),
  onRemoveAttachment: PropTypes.func
}

export default Attachment
